import { render } from "./DownloadPDFButton.vue?vue&type=template&id=7d3a98c6"
import script from "./DownloadPDFButton.vue?vue&type=script&lang=js"
export * from "./DownloadPDFButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__